import dompurify from 'dompurify';

import autolinker from 'autolinker';

angular.module('shared').directive('textareaContent', function() {
  return {
    restrict: 'E',
    scope: {
      text: '='
    },
    controller: ["$scope", function($scope) {
      return $scope.getText = function() {
        var escaped, withBreaks, withLinks;
        escaped = _.escape($scope.text);
        withLinks = autolinker.link(escaped);
        withBreaks = withLinks.replace(/\n/g, '<br/>');
        return dompurify.sanitize(withBreaks, {
          ALLOWED_TAGS: ['a', 'br'],
          ALLOWED_ATTR: ['target', 'href', 'rel']
        });
      };
    }],
    template: `<div ng-bind-html="getText()"></div>`
  };
});
